function createOverlay(image) {
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const container = overlay.getBoundingClientRect();
  const xPosition = Math.min(Math.max(event.clientX - container.left, 0), container.width);
  const yPosition = Math.min(Math.max(event.clientY - container.top, 0), container.height);
  const xPercent = `${(xPosition / container.width) * 100}%`;
  const yPercent = `${(yPosition / container.height) * 100}%`;
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px ${image.clientHeight * zoomRatio}px`;
}

function magnify(image, event, zoomRatio) {
  image.parentElement.querySelector('.image-magnify-full-size')?.remove();
  const overlay = createOverlay(image);
  moveWithHover(image, overlay, event, zoomRatio);
  overlay.addEventListener('pointermove', (pointerEvent) => moveWithHover(image, overlay, pointerEvent, zoomRatio));
  overlay.addEventListener('pointerleave', () => overlay.remove(), { once: true });
}

function enableZoomOnHover(zoomRatio) {
  if (!globalThis.matchMedia?.('(hover: hover) and (pointer: fine)').matches) return;
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.lsZoomBound === 'true') return;
    image.dataset.lsZoomBound = 'true';
    image.addEventListener('pointerenter', (event) => magnify(image, event, zoomRatio));
  });
}

enableZoomOnHover(2);
